import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const countableUnitSubTypeServices = {
	getSubUnits,
	createSubUnit,
	deleteSubUnit,
};

function getSubUnits() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(endpoints.COUNTABLE_SUBUNIT_LIST, requestOptions).then(
		handleResponse
	);
}

function createSubUnit(data) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(data),
	};
	return fetch(endpoints.COUNTABLE_SUBUNIT_CREATE, requestOptions).then(
		handleResponse
	);
}

function deleteSubUnit(data) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(data),
	};
	return fetch(endpoints.COUNTABLE_SUBUNIT_DELETE, requestOptions).then(
		handleResponse
	);
}

export default countableUnitSubTypeServices;
